"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class StableValueProvider extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "StableValueProvider";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/stable-value-providers"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create stable value providers.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/stable-value-providers/" +
      this.code
    );
  }

  getAdminPath() {
    console.error("Cannot go to a stable value provider.");
  }

  get searchResultTitle() {
    return this.displayName;
  }

  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default StableValueProvider;
